<template>
    <div style="height: 100%;width: 100%;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-form label-width="140px" class="orderFrom">
            <el-form-item label="今年到店次数">
                {{HairDd.year}}
            </el-form-item>
            <el-form-item label="平均每月到店次数">
                {{HairDd.months}}
            </el-form-item>
            <el-form-item label="上月到店次数">
                {{HairDd.befMonth}}
            </el-form-item>
            <el-form-item label="本月到店次数">
                {{HairDd.curMonth}}
            </el-form-item>
            <el-form-item label="预约未到店次数">
                {{HairDd.yywdd}}
            </el-form-item>
        </el-form>
        <el-descriptions direction="vertical" :column="2" border>
            <el-descriptions-item label="消费日期">
                {{$moment(cardTrans.accountdate).format('YYYY-MM-DD')}}
            </el-descriptions-item>
            <el-descriptions-item label="消费项目">
                <div v-for="(item,key) in cardTrans.cardTransactionHistories" :key="key">
                    {{item.projectname}}({{item.amount}})
                </div>
            </el-descriptions-item>
            <el-descriptions-item label="提醒日期">
                {{beautyXfLog.nextdate}}
            </el-descriptions-item>
            <el-descriptions-item label="执行情况">
            </el-descriptions-item>
            <el-descriptions-item label="上次预约">
                {{befOrderInfo.accountdate}}
            </el-descriptions-item>
            <el-descriptions-item label="执行情况">
                <el-tag v-if="befOrderInfo.status==99">已到店</el-tag>
                <el-tag v-if="befOrderInfo.status==1">未到店</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="预约日期">
                {{orderInfo.accountdate}}
            </el-descriptions-item>
            
            <el-descriptions-item label="执行情况">
                <span v-if="orderInfo.accountdate!=null">已执行</span>
                <el-button size="mini" type="primary" v-else @click="openAddYy">预约</el-button>
            </el-descriptions-item>
        </el-descriptions>
    </div>

</template>
<script>
    export default {
        data() {
            return {
                HairDd:{
                    year:0,
                    months:0,
                    yywdd:0,
                    befMonth:0,
                    curMonth:0,
                },
                cardTrans:{},
                cardTrans:{},
                beautyXfLog:{},
                orderInfo:{},
                befOrderInfo:{},
                storeid:localStorage.getItem("storeid"),
                cardid:"",
            }
        },
        created: function () {
            this.cardid=this.$route.query.cardid;
            this.getHairManagerClientCount();
            this.getHairAppYyData();
        },
        methods: {
            openAddYy(row){
                this.$router.push({path:"/addhairorder",query:{
                    cardid:this.cardid,
                }});
            },
            getHairAppYyData(){
                this.$post("hairmanager/getHairAppYyData",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj.cardTrans!=null){
                            this.cardTrans=obj.cardTrans;
                        }
                        if(obj.beautyXfLog!=null){
                            this.beautyXfLog=obj.beautyXfLog;
                        }
                        if(obj.orderInfo!=null){
                            this.orderInfo=obj.orderInfo;
                        }
                        if(obj.befOrderInfo!=null){
                            this.befOrderInfo=obj.befOrderInfo;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getHairManagerClientCount(){
                this.$post("hairmanager/getHairManagerClientCount",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        this.HairDd.year=obj.year;
                        this.HairDd.months=obj.months;
                        this.HairDd.yywdd=obj.yywdd;
                        this.HairDd.befMonth=obj.befMonth;
                        this.HairDd.curMonth=obj.curMonth;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>

<style style lang="scss" rel="stylesheet/scss">
    .orderFrom .el-form-item{
        margin-bottom:0px;
    }
</style>


// WEBPACK FOOTER //
// src/page/manager/hairorder.vue